import { render, staticRenderFns } from "./TipoContacto.vue?vue&type=template&id=3c19371a&"
import script from "./TipoContacto.vue?vue&type=script&lang=ts&"
export * from "./TipoContacto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3c19371a', component.options)
    } else {
      api.reload('3c19371a', component.options)
    }
    module.hot.accept("./TipoContacto.vue?vue&type=template&id=3c19371a&", function () {
      api.rerender('3c19371a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TipoContacto/TipoContacto.vue"
export default component.exports